<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">维保记录</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">设备名称</div>
                    <div class="header-item">设备序列号</div>
                    <div class="header-item">维保时间</div>
                    <div class="header-item">维保内容</div>

                    <div class="header-item">备注</div>
                    <div class="header-item">操作人</div>
                    <div class="header-item">功能间</div>

                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in displayRecordList" :key="index">
                            <div class="body-item">{{ item.deviceName }}</div>
                            <div class="body-item">{{ item.deviceSerialnumber }}</div>
                            <div class="body-item">{{ item.dateTime }}</div>
                            <div class="body-item"> {{ item.content }}</div>
                            <div class="body-item"> {{ item.remark }}</div>
                            <div class="body-item"> {{ item.repairman }}</div>
                            <div class="body-item"> {{ item.room }}</div>
                        </div>
                        <div class="empty-tip" v-if="displayRecordList.length === 0">
                            暂无维保记录
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>


</template>

<script>
import { getRoomList } from "@/api/function";
import { getMaintenanceList } from "@/api/maintenance";

export default {
    data() {
        return {
            // 搜索表单：对齐维保记录字段
            searchForm: {
                deviceName: '',
                dateRange: ''
            },
            roomList: [],
            allRecordList: [], // 存储全量维保记录（仅初始化加载一次）
            filteredRecordList: [], // 前端过滤后的记录
            displayRecordList: [], // 当前页显示的记录
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,
            // 抽屉相关
            detailDrawerVisible: false,
            currentRecord: {
                accessories: [],
                frontPhoto: [],
                middlePhoto: [],
                afterPhoto: []
            }, // 当前选中的维保记录
            // 【新增】Tab的激活状态
            activeTab: 'accessories',
        };
    },
    mounted() {
        this.initData();
    },
    methods: {

        // 初始化数据
        async initData() {
            try {
                await this.loadRoomList();
                // 加载全量维保记录（不带任何过滤条件）
                await this.loadAllMaintenanceRecords();
                // 初始化过滤（默认显示全部）
                this.filterRecords();
            } catch (error) {
                this.$message.error('数据初始化失败');
                console.error('初始化失败：', error);
            }
        },

        // 加载功能间列表
        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
            }
        },

        // 【核心修改】加载全量维保记录（仅传递userId，不传递过滤条件）
        async loadAllMaintenanceRecords() {
            this.loading = true;
            try {
                const res = await getMaintenanceList({
                    userId: localStorage.getItem('userId'),
                    // 移除设备名称和日期范围参数，只获取全量数据
                });
                console.log('全量维保记录数据：', res.data);
                // 处理后端返回格式
                if (res.data && res.data.records) {
                    this.allRecordList = res.data.records || [];
                } else {
                    this.allRecordList = res.data || [];
                }
            } catch (error) {
                this.$message.error('加载维保记录异常，请重试');
                this.allRecordList = [];
            } finally {
                this.loading = false;
            }
        },

        // 【核心新增】前端过滤逻辑（设备名称 + 日期范围）
        filterRecords() {
            let filtered = [...this.allRecordList];

            // 1. 设备名称过滤（模糊匹配，不区分大小写）
            if (this.searchForm.deviceName.trim()) {
                const keyword = this.searchForm.deviceName.trim().toLowerCase();
                filtered = filtered.filter(record => {
                    return record.deviceName && record.deviceName.toLowerCase().includes(keyword);
                });
            }

            // 2. 日期范围过滤
            if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                const startDate = new Date(this.searchForm.dateRange[0]);
                const endDate = new Date(this.searchForm.dateRange[1]);
                // 处理维保时间格式，提取日期部分进行比较
                filtered = filtered.filter(record => {
                    if (!record.dateTime) return false;
                    // 提取dateTime的日期部分（兼容 "yyyy-MM-dd" 或 "yyyy-MM-dd HH:mm:ss" 格式）
                    const recordDateStr = record.dateTime.split(' ')[0];
                    const recordDate = new Date(recordDateStr);
                    // 确保日期在选择的范围内
                    return recordDate >= startDate && recordDate <= endDate;
                });
            }

            // 更新过滤后的列表和总数
            this.filteredRecordList = filtered;
            this.totalCount = filtered.length;
            // 重新分页
            this.paginateData();
        },

        // 根据功能间id获取名称
        getRoomName(roomId) {
            if (!roomId) return '未知功能间';
            const room = this.roomList.find(item => item.id === roomId || item.id === Number(roomId));
            return room ? room.roomName : '未知功能间';
        },



        // 分页处理
        paginateData() {
            if (this.filteredRecordList.length === 0) {
                this.displayRecordList = [];
                return;
            }
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.filteredRecordList.slice(startIndex, endIndex);
        },




    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>